import { asyncLoad } from '@util'
import JiaMengHeader from '@components/JiaMeng/Header/Customer'
import React from 'react'

export default {
  path: 'customerManage',
  component: props => <JiaMengHeader key="customerManage" {...props} />,
  indexRoute: {
    component: asyncLoad(() =>
      import('@components/LocalMerchant/Customer/List')
    )
  },
  stat: '客资列表/首页',
  childRoutes: [
    {
      path: 'edit(/:id)',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/Customer/Edit')
      ),
      stat: '客资列表/客资详情'
    }
  ]
}
